import createRoot from "react-dom";
import App from "./App";
import "../src/style.css";

createRoot.render(<App />, document.getElementById("root"));
